module.exports = __webpack_public_path__ + "static/Sothebys_International_Realty-8b60d47def77f293fd7dee3c8597dd9f.png";